import Entity from './Entity';

export type EpisodeVisibility =
  | 'open_to_all'
  | 'members_only'
  | 'paid'
  | 'subscription';

export default class Episode implements Entity {
  constructor(
    public id: number,
    public storyId: number,
    public title: string,
    public visibility: EpisodeVisibility,
    public amount: number | null,
    public published: boolean,
    public publishedUpdatedAt: Date,
    public scheduledDeliveredAt: Date | null,
    public nextScheduledDelivery: boolean,
    public numberOfStory: number,
    public updatedAt: Date,
    public createdAt: Date,
  ) {}
}
